// name of fields in CreationWizard root component state

// we're importing this on purpose, as CreationWizard and the header file props definition is the props implicit define in this file
import ChooseInstallableMixinProps from '../common/ChooseInstallableMixin.props';

export default {
	...ChooseInstallableMixinProps,
	selectedAppId: { type: Number },
};
